import { useSuspenseQuery } from '@tanstack/react-query';
import { User } from '@outdoria/types';
import { fetcher } from '../utils';

export const useUserApi = (userId: string | null | undefined) => {
  const getUser = async (): Promise<User> => {
    const res = await fetcher(`/v1/users/user/${userId}`);
    return res.json();
  };

  const { data, isLoading, isFetched, isError } = useSuspenseQuery<
    User,
    unknown,
    User,
    string[]
  >({
    queryKey: ['user', userId!],
    queryFn: getUser,
    // enabled: Boolean(userId),
  });

  return { data, isLoading, isFetched, isError };
};
